require('./bootstrap');

import Alpine from 'alpinejs';
import FormsAlpinePlugin from '../../../../vendor/filament/forms/dist/module.esm';
import NotificationsAlpinePlugin from '../../../../vendor/filament/notifications/dist/module.esm'
import CustomFormsAlpinePlugin from './custom-filament/index';
import Tooltip from "@ryangjchandler/alpine-tooltip";

import FlatPicr from "flatpickr";
Alpine.plugin(FormsAlpinePlugin);
Alpine.plugin(NotificationsAlpinePlugin);
Alpine.plugin(CustomFormsAlpinePlugin);
Alpine.plugin(Tooltip);

Alpine.plugin(FlatPicr);

window.Alpine = Alpine;

Alpine.start();
